import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    loginWithRedirect();
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  return <div></div>;
};

export default Login;
